import { render, staticRenderFns } from "./SubtabCamera.vue?vue&type=template&id=525ccd08&scoped=true"
import script from "./SubtabCamera.vue?vue&type=script&lang=js"
export * from "./SubtabCamera.vue?vue&type=script&lang=js"
import style0 from "./SubtabCamera.vue?vue&type=style&index=0&id=525ccd08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525ccd08",
  null
  
)

export default component.exports